'use client';

import PropTypes from 'prop-types';
import { Box } from '@mui/material';

export default function MarketingVideoEmbed({ src, title }) {
  return (
    <Box
      component="figure"
      sx={{
        m: 0,
        my: { xs: 3, md: 4 },
        width: '100%',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '16 / 9',
          bgcolor: 'grey.900',
        }}
      >
        <Box
          component="iframe"
          src={src}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            border: 0,
            display: 'block',
          }}
        />
      </Box>
    </Box>
  );
}

MarketingVideoEmbed.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
